import * as TypeAction from './actionTypes'
import { actionSincCRUD, actionSyncListObj, TypeErro, tratarErroFiretore } from 'scorpion-core';
import { salva, manterSincronizacao } from './api';
import { auth } from "../../../firebase"
import { salvar as salvarPerfil } from '../../private/PerfilUsuario/actions'
export const signin = (email, senha, retorno) => (dispatch) => {
    try {
        actionSincCRUD(auth.doSignInWithEmailAndPassword(email, senha), TypeAction.SIGNIN, dispatch, retorno)
    } catch (error) {
        dispatch({ type: TypeErro(TypeAction.SIGNIN), payload: tratarErroFiretore(error.message) })
    }
}
export const signinGoogle = (retorno) => (dispatch) => {
    try {
        actionSincCRUD(auth.signInGoogle(), TypeAction.SIGNIN, dispatch, retorno)
    } catch (error) {
        dispatch({ type: TypeErro(TypeAction.SIGNIN), payload: error })
    }
}

export const createUser = (nome, email, senha, retorno) => (dispatch) => {
    let camposCriacao = { nome }
    try {
        actionSincCRUD(auth.doCreateUserWithEmailAndPassword(email, senha), TypeAction.SIGNUP, dispatch, ({user}) => {
            const { displayName, email, emailVerified, phoneNumber, photoURL, metadata: { creationTime } } = user;
            let perfil = { nome: displayName, email, emailVerified, telefone: phoneNumber, photoURL, creationTime, ...camposCriacao }
            salvarPerfil(perfil)(dispatch)
            if (retorno) {
                retorno(user)
            }

        })
    } catch (error) {
        dispatch({ type: TypeErro(TypeAction.SIGNUP), payload: tratarErroFiretore(error.message) })
    }
}

export const logOut = () => (dispatch) => {
    actionSincCRUD(auth.doSignOut(), TypeAction.SIGNIN, dispatch)
}
export const listar = () => (dispatch) => {
    manterSincronizacao(actionSyncListObj(TypeAction.LISTAR, dispatch));
}






// WEBPACK FOOTER //
// ./src/routes/public/Login/actions.js